import { render, staticRenderFns } from "./addCloudDisk.vue?vue&type=template&id=55a096e0&scoped=true"
import script from "./addCloudDisk.vue?vue&type=script&lang=js"
export * from "./addCloudDisk.vue?vue&type=script&lang=js"
import style0 from "./addCloudDisk.vue?vue&type=style&index=0&id=55a096e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a096e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55a096e0')) {
      api.createRecord('55a096e0', component.options)
    } else {
      api.reload('55a096e0', component.options)
    }
    module.hot.accept("./addCloudDisk.vue?vue&type=template&id=55a096e0&scoped=true", function () {
      api.rerender('55a096e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/addCloudDisk.vue"
export default component.exports